import React from "react";
import Money from "components/money";
import { useSelector, useDispatch } from "react-redux";
import { CLOSE_CART } from "utils/action-types";
import Link from "helpers/link";
import { useGlobalContext } from "context/global";
import { ReactComponent as PlaceHolder } from "assets/svgs/image-placeholder.svg";
import CartItemControls from "./item-controls";
import clsx from "clsx/lite";

const CartItem = ({ product, onRemoved }) => {
	const { activeBox } = useSelector(state => state.cart);
	const { translation } = useGlobalContext();

	const { title, image, handle, variant, quantity, stock, oneTime } = product;

	let compareAtPrice = !variant.weight ? variant.totalPrice : parseFloat(variant.price * quantity);
	let price = variant.weight ? compareAtPrice : variant.totalDiscountedPrice;

	if (variant.weight && variant.weight >= 1) {
		// If the item is a double portion, apply the double portion discount
		price -= (activeBox?.discount * quantity * variant.weight);
	}

	const hasDiscount = variant.weight >= 1 && compareAtPrice > price;
	const isFree = (variant.price === 0 || variant.totalDiscountedPrice === 0);

	return (
		<div className="flex justify-between items-center">
			<ProductLink handle={handle} isFree={isFree}>
				{image?.src ? <img width="60px" src={image.src} alt={image.altText} /> :
					<div className="flex justify-center items-center size-15 border rounded-lg border-[#DBDBDB]">
						<PlaceHolder />
					</div>}
			</ProductLink>
			<div className="flex-[1] flex flex-col ml-2.5">
				<ProductLink className="text-sm font-normal text-left hover:underline" handle={handle} isFree={isFree}>
					{title}
				</ProductLink>
				{!isFree &&
					<p className="text-sm font-light text-[#757575]">
						{hasDiscount && <span className="text-sm">
							<Money value={price} />
						</span>}
						<span className={clsx("text-sm", hasDiscount && "line-through ml-2")}
							aria-label={hasDiscount ? `Original price: ${compareAtPrice}` : ""}>
							<Money value={hasDiscount ? compareAtPrice : price} />
						</span>
					</p>
				}
				{isFree && <span className="text-xs bg-[#97AB51] w-max rounded-xl px-3 py-1 mt-1">
					{translation?.product?.freeGift}
				</span>}
				{(stock === "one-time" || oneTime) &&
					<span className="one-time-badge">
						{translation.cart?.oneTime}
					</span>}
			</div>
			<CartItemControls product={product} onRemoved={onRemoved} />
		</div>
	);
};

const ProductLink = ({ handle, className, isFree, children }) => {
	const dispatch = useDispatch();
	if (isFree) return <>{children}</>;

	return (
		<Link className={className} to={`/products/${handle}`} onClick={() => dispatch({ type: CLOSE_CART })}>
			{children}
		</Link>
	);
};

export default CartItem;
